export type ToolbarIcon = 'close' | 'contents' | 'download' | 'wrap' | 'width' | 'page' | 'left' | 'right';

// Original toolbar icons; no external icon assets or fonts are required.
const paths: Record<ToolbarIcon, string> = {
  close: '<path d="m6 6 12 12M18 6 6 18"/>',
  contents: '<rect x="3" y="4" width="18" height="16" rx="1"/><path d="M8 4v16M11 8h7M11 12h7M11 16h5"/>',
  download: '<path d="M12 3v12m-4-4 4 4 4-4M4 16v5h16v-5"/>',
  wrap: '<path d="M3 5h18M3 10h14a4 4 0 0 1 0 8h-5m3-3-3 3 3 3M3 15h5M3 20h5"/>',
  width: '<rect x="3" y="5" width="18" height="14" rx="1"/><path d="M6 12h12m-9-3-3 3 3 3m6-6 3 3-3 3"/>',
  page: '<rect x="5" y="3" width="14" height="18" rx="1"/><path d="M9 7h6M9 17h6"/>',
  left: '<path d="M4 8h9a7 7 0 1 1-7 10M4 8l4-4M4 8l4 4"/>',
  right: '<path d="M20 8h-9a7 7 0 1 0 7 10M20 8l-4-4M20 8l-4 4"/>'
};

/**
 * Draws one of the toolbar icons inside a button.
 *
 * @param {HTMLElement} button The button to fill.
 * @param {ToolbarIcon} kind Which icon to draw.
 */
export function setToolbarIcon(button: HTMLElement, kind: ToolbarIcon): void {
  button.innerHTML =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" ' +
    `stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths[kind]}</svg>`;
}
